const theme = {
  colors: {
    primary: '#4F46E5',
    primaryDark: '#4338CA',
    primaryLight: '#EEEDFC',
    primaryGradient: 'linear-gradient(135deg, #4338CA 0%, #4F46E5 100%)',
    headerGradient: 'linear-gradient(135deg, #4338CA 0%, #4F46E5 50%, #6D66EE 100%)',
    studentHeaderGradient: 'linear-gradient(135deg, #15803D 0%, #1EA750 50%, #18944A 100%)',
    studentPrimary: '#22C55E',
    studentPrimaryLight: '#E8F5E9',
    parentHeaderGradient: 'linear-gradient(135deg, #7B1FA2 0%, #9C27B0 50%, #8E24AA 100%)',
    parentPrimary: '#AB47BC',
    parentPrimaryLight: '#F3E5F5',

    secondary: '#FF9800',
    secondaryLight: '#FFE0B2',

    accent: {
      blue: '#42A5F5',
      blueLight: '#E3F2FD',
      orange: '#FF9800',
      orangeLight: '#FFF3E0',
      red: '#EF5350',
      redLight: '#FFEBEE',
      green: '#22C55E',
      greenLight: '#E8F5E9',
      purple: '#AB47BC',
      purpleLight: '#F3E5F5',
      gold: '#C9A24B',
      goldLight: '#F5EAD0',
    },

    text: {
      primary: '#1A1A2E',
      secondary: '#4B5563',
      hint: '#6B7280',
      white: '#FFFFFF',
    },

    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
      card: '#FFFFFF',
    },

    border: '#E5E7EB',
    divider: '#F3F4F6',

    status: {
      urgent: '#EF5350',
      inProgress: '#42A5F5',
      completed: '#22C55E',
      notSubmitted: '#FF9800',
      overdue: '#EF5350',
    },

    role: {
      teacher: '#4F46E5',
      student: '#22C55E',
      assistant: '#F59E0B',
      parent: '#AB47BC',
    },
  },

  borderRadius: {
    small: '8px',
    medium: '16px',
    large: '20px',
    round: '50%',
    pill: '999px',
  },

  shadow: {
    small: '0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.08)',
    large: '0 8px 24px rgba(0, 0, 0, 0.12)',
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  fontSize: {
    xs: '11px',
    sm: '13px',
    md: '15px',
    lg: '17px',
    xl: '20px',
    xxl: '24px',
    title: '28px',
  },
};

export default theme;
